export default __webpack_public_path__ + "static/media/twitter.c83e34af.svg";